export default __webpack_public_path__ + "static/media/create_course_lesson.840bdfcc.svg";